import { ResolvedTenant } from 'types/tenant';

let resolvedTenant: ResolvedTenant | null = null;

export const setResolvedTenant = (tenant: ResolvedTenant): void => {
  resolvedTenant = tenant;
};

export const getResolvedTenant = (): ResolvedTenant | null => resolvedTenant;

export const getResolvedTenantCode = (): string | null => resolvedTenant?.tenantCode ?? null;
